import React, { Fragment } from 'react';
import { SvgIcon, SvgIconProps } from '../components';

export default function BurgerUpTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <Fragment>
      <path d="M.973 3.586h18.21c.409 0 .783-.414.783-.793 0-.414-.408-.793-.783-.793H.973c-.408 0-.782.414-.782.793 0 .38.408.793.782.793zm17.594 5.413H1.103C.528 8.999 0 9.412 0 9.792c0 .413.576.793 1.103.793h17.464c.576 0 1.104-.414 1.104-.793 0-.38-.432-.793-1.104-.793zm.65 7.067H1.11c-.409 0-.783.414-.783.793 0 .414.408.793.783.793h18.107c.409 0 .783-.414.783-.793 0-.413-.408-.793-.783-.793z" />
      </Fragment>
    </SvgIcon>
  );
}
